.doc {
  padding: 4px var(--gutter) 40px;
  font-size: var(--fs-sm);
  line-height: 1.65;
  color: var(--text-2);
}

.doc h2 {
  margin: 28px 0 8px;
  font-size: var(--fs-md);
  font-weight: 800;
  color: var(--text);
}

.doc p,
.doc ul {
  margin: 0 0 10px;
}

.doc ul {
  padding-left: 20px;
}

.doc li {
  margin-bottom: 4px;
}

.doc strong {
  color: var(--text);
}

.doc a {
  color: var(--accent);
  text-decoration: underline;
}

.meta {
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.table {
  width: 100%;
  margin: 8px 0 12px;
  border-collapse: collapse;
  font-size: var(--fs-xs);
}

.table th,
.table td {
  padding: 8px 6px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  vertical-align: top;
}

.table th {
  color: var(--text);
  font-weight: 700;
}
